import React, { useState, useEffect, useMemo, useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import '../styles/AboutMe.css';
import image from '../assets/images/AboutMe/IMG_4822.jpg';

const AboutMe = () => {
  const birthDate = useMemo(() => new Date('2005-03-11'), []);
  const { translations } = useContext(LanguageContext)

  const calculateAge = (birthDate) => {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) { age--; }

    return age;
  };

  const [age, setAge] = useState(calculateAge(birthDate));

  useEffect(() => {
    setAge(calculateAge(birthDate));
  }, [birthDate]);

  return (
    <div className="about-me-wrapper">
      <div className="about-me-container">
        <div className="side-text-container">
          <div className="image-container">
            <img src={image} alt="Viktor Asenov" />
          </div>
          <div className="side-text-content">
            <h1>{translations.aboutMe.title}</h1>
            <p> { translations.aboutMe.greeting_part1 } <strong>{translations.aboutMe.name}</strong>, {translations.aboutMe.greeting_special} {age} {translations.aboutMe.greeting_part2} </p>
            <p style={{textIndent: '30px'}} > { translations.aboutMe.paragraph1 }</p>
            <p style={{textIndent: '30px'}} >
              { translations.aboutMe.paragraph2_part1 } <i>"{ translations.aboutMe.paragraph2_part2 }"</i>, <i>"{ translations.aboutMe.paragraph2_part3 }"</i>{ translations.aboutMe.paragraph2_part4 }<strong> { translations.aboutMe.paragraph2_part5 }</strong>. </p>
          </div>
        </div>
        <div className="full-width-text-container">
          <p style={{textIndent: '30px'}} >
            { translations.aboutMe.paragraph3_part1 }<a href="https://uktc-bg.com/" target="_blank" rel='noreferrer'>{translations.aboutMe.paragraph3_part2 }</a> { translations.aboutMe.paragraph3_part3 } <i><q>{ translations.aboutMe.paragraph3_part4 }</q></i>. <strong>{ translations.aboutMe.paragraph3_part5 }</strong> { translations.aboutMe.paragraph3_part6 } <i>{translations.aboutMe.paragraph3_part7}</i>{ translations.aboutMe.paragraph3_part8 } <strong>{ translations.aboutMe.paragraph3_part9 }</strong>.           
          </p>
          <p style={{textIndent: '30px'}} >
            { translations.aboutMe.paragraph4_part1 }<i>{ translations.aboutMe.paragraph4_part2 }</i>{ translations.aboutMe.paragraph4_part3 }<strong><i>{ translations.aboutMe.paragraph4_part4 }</i></strong>{ translations.aboutMe.paragraph4_part5 }<strong>{ translations.aboutMe.paragraph4_part6 }</strong>. 
          </p>
          <p>
            { translations.aboutMe.paragraph5_part1 }<a href="https://www.jku.at/en" target="_blank" rel='noreferrer'>{ translations.aboutMe.paragraph5_part2 }</a>{ translations.aboutMe.paragraph5_part3 }<strong><i><q>{ translations.aboutMe.paragraph5_part4 }</q></i></strong>.
          </p>
          <p>
            {translations.aboutMe.paragraph6_part1}<strong><i>{translations.aboutMe.paragraph6_part2}</i></strong> {translations.aboutMe.paragraph6_part3} <strong><i>{translations.aboutMe.paragraph6_part4}</i></strong>.
          </p>
          <p> { translations.aboutMe.paragraph7 } </p>
          <p> { translations.aboutMe.paragraph8 } </p>
          <p>
            {translations.aboutMe.paragraph9_part1}<a href="/Contact">{translations.aboutMe.paragraph9_part2}</a>{ translations.aboutMe.paragraph9_part3 }
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
